export const useFileInfo = (file: IFile) => {
  let fileSize: string

  const fileType = '.' + /[^.]*$/.exec(file.name)![0]
  const fileName = /.*(?=\.)/.exec(file.name)![0]

  if (file.size === 0) {
    fileSize = '0 Bytes'
  } else {
    const k = 1000
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(file.size) / Math.log(k))

    fileSize =
      parseFloat((file.size / Math.pow(k, i)).toFixed(0)) + ' ' + sizes[i]
  }

  return {
    fileType,
    fileName,
    fileSize,
  }
}
